module.exports = __webpack_public_path__ + "static/media/ChoralPic.e744f9c2.png";